import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";

// Course Retrieval App Images (React Native - Mobile)
import courseRetrieval1 from "../../Assets/Projects/AI Course Retrieval/1.png";
import courseRetrieval2 from "../../Assets/Projects/AI Course Retrieval/2.png";
import courseRetrieval3 from "../../Assets/Projects/AI Course Retrieval/3.png";
import courseRetrieval4 from "../../Assets/Projects/AI Course Retrieval/4.png";
import courseRetrieval5 from "../../Assets/Projects/AI Course Retrieval/5.png";
import courseRetrieval6 from "../../Assets/Projects/AI Course Retrieval/6.png";

// Cricket Dashboard Images (Web)
import cricketDashboard1 from "../../Assets/Projects/Cricket Dashboard/Screenshot (288).png";
import cricketDashboard2 from "../../Assets/Projects/Cricket Dashboard/Screenshot (289).png";
import cricketDashboard3 from "../../Assets/Projects/Cricket Dashboard/Screenshot (290).png";
import cricketDashboard4 from "../../Assets/Projects/Cricket Dashboard/Screenshot (291).png";
import cricketDashboard5 from "../../Assets/Projects/Cricket Dashboard/Screenshot (292).png";
import cricketDashboard6 from "../../Assets/Projects/Cricket Dashboard/Screenshot (293).png";
import cricketDashboard7 from "../../Assets/Projects/Cricket Dashboard/Screenshot (294).png";
import cricketDashboard8 from "../../Assets/Projects/Cricket Dashboard/Screenshot (295).png";
import cricketDashboard9 from "../../Assets/Projects/Cricket Dashboard/Screenshot (296).png";

// Weather App Images (Web)
import weatherApp1 from "../../Assets/Projects/weather app/Screenshot (299).png";
import weatherApp2 from "../../Assets/Projects/weather app/Screenshot (300).png";
import weatherApp3 from "../../Assets/Projects/weather app/Screenshot (301).png";
import weatherApp4 from "../../Assets/Projects/weather app/Screenshot (302).png";

// Single Image Projects
import cvMatchingSaas from "../../Assets/Projects/CV Matching SaaS.png";
import universityExplorer from "../../Assets/Projects/University Explorer & WEATHER NOTIFIER.png";
import whataiChatbot from "../../Assets/Projects/WhatAI-Chatbot.jpg";
import bbcClone from "../../Assets/Projects/BBC Clone.png";
import quizooApp from "../../Assets/Projects/Quizoo – Android Quiz App (Kotlin & Firebase).png";
import informationManagement from "../../Assets/Projects/Information Management System.png";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Specializing in <strong className="purple">React Native</strong>{" "}
          mobile development and <strong className="purple">React</strong> web
          applications.
        </p>

        {/* Web Development Section */}
        <h2
          className="project-heading"
          style={{ fontSize: "2.1em", paddingTop: "30px" }}
        >
          <strong className="purple">Web Applications</strong>
        </h2>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          {/* CV Matching SaaS - Next.js/React (Priority 1) */}
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={cvMatchingSaas}
              isBlog={false}
              title="CV Matching SaaS Platform"
              description="A high-performance SaaS application built with Next.js, TypeScript, and React. Features AI-based CV matching, server-side rendering (SSR), advanced state management, and enterprise-grade scalability with modern development patterns."
              ghLink="https://github.com/JamshaidAhmedd/cv-matching-saas"
              demoLink="https://cv-matching-saas-ne63.vercel.app/Dashboard"
              techStack="Next.js • React • TypeScript • SSR • AI"
            />
          </Col>

          {/* University Explorer - MERN Stack (Priority 2) */}
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={universityExplorer}
              isBlog={false}
              title="University Explorer Platform"
              description="A comprehensive MERN stack application with React frontend, Node.js/Express backend, and MongoDB. Features advanced university search, real-time weather notifications, automated email/SMS services, and background job processing."
              ghLink="https://github.com/JamshaidAhmedd/University-Explorer-Weather-Notifier-"
              techStack="React • Node.js • Express • MongoDB • MERN"
            />
          </Col>

          {/* Cricket Dashboard - Laravel (Priority 3) */}
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={[
                cricketDashboard1,
                cricketDashboard2,
                cricketDashboard3,
                cricketDashboard4,
                cricketDashboard5,
                cricketDashboard6,
                cricketDashboard7,
                cricketDashboard8,
                cricketDashboard9,
              ]}
              isBlog={false}
              title="Real-time Cricket Dashboard"
              description="A data-intensive web application built with Laravel and MySQL for live cricket analytics. Features RESTful API integrations, real-time match updates, comprehensive team statistics, and responsive dashboard with dynamic data visualization."
              ghLink="https://github.com/JamshaidAhmedd/Cricket-Dashboard-Web-App"
              techStack="Laravel • MySQL • APIs • Real-time Data"
            />
          </Col>

          {/* Information Management System - Vue.js/Django (Priority 4) */}
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={informationManagement}
              isBlog={false}
              title="Research Management System"
              description="A full-stack application with Vue.js frontend and Django REST framework backend. Manages researcher profiles, scientific projects, events, and reports with modular architecture, JWT authentication, and dynamic routing."
              ghLink="https://github.com/JamshaidAhmedd/NCP-Information-System"
              techStack="Vue.js • Django • REST API • JWT Auth"
            />
          </Col>

          {/* BBC Clone CMS - Laravel (Priority 5) */}
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={bbcClone}
              isBlog={false}
              title="BBC Clone CMS"
              description="A sophisticated content management system replicating BBC's interface using Laravel and MySQL. Features role-based access control, comprehensive CRUD operations, media management, and fully responsive design with Blade templating."
              ghLink="https://github.com/JamshaidAhmedd/BBC-Clone-Interface"
              techStack="Laravel • MySQL • CMS • Responsive Design"
            />
          </Col>

          {/* Weather App - PHP (Priority 6) */}
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={[weatherApp1, weatherApp2, weatherApp3, weatherApp4]}
              isBlog={false}
              title="WeatherNow Application"
              description="A dynamic weather application built with PHP and MySQL featuring real-time API integration. Includes intelligent client-side caching, asynchronous data fetching, and responsive design. Achieved 6th position in competitive programming challenge."
              ghLink="https://github.com/JamshaidAhmedd/WeatherNow-Weather-Application-HTML-CSS-JS"
              techStack="PHP • MySQL • Weather APIs • Responsive"
            />
          </Col>
        </Row>
        {/* Mobile Development Section */}
        <h2
          className="project-heading"
          style={{ fontSize: "2.1em", paddingTop: "20px" }}
        >
          <strong className="purple">Mobile Applications</strong>
        </h2>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          {/* Course Retrieval App - React Native (Priority 1) */}
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={[
                courseRetrieval1,
                courseRetrieval2,
                courseRetrieval3,
                courseRetrieval4,
                courseRetrieval5,
                courseRetrieval6,
              ]}
              isBlog={false}
              title="AI Course Retrieval App"
              description="A premium React Native mobile application with Python backend for intelligent course discovery. Features AI-powered sentiment analysis, personalized recommendations, and advanced filtering. Showcases modern mobile development with cross-platform compatibility and optimal performance."
              ghLink="https://github.com/JamshaidAhmedd/AI-Course-Retrieval-App"
              techStack="React Native • Python • AI/ML • Cross-Platform"
            />
          </Col>

          {/* Quizoo Android App - Kotlin (Priority 2) */}
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={quizooApp}
              isBlog={false}
              title="Quizoo – Android Quiz App"
              description="A feature-rich Android application built with Kotlin and Firebase. Implements real-time scoring, dynamic category filters, offline data persistence, and Material Design 3. Demonstrates modern Android development practices with clean architecture."
              ghLink="https://github.com/JamshaidAhmedd/Quiz_App_Kotlin"
              techStack="Kotlin • Firebase • Android • Material Design"
            />
          </Col>

          {/* WhatsApp AI Chatbot - Node.js (Priority 3) */}
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={whataiChatbot}
              isBlog={false}
              title="WhatsApp AI Chatbot"
              description="An intelligent NLP-powered chatbot built with Node.js and Baileys API. Features sophisticated conversation flow, automated course inquiries, and seamless WhatsApp Business integration for enhanced customer experience."
              ghLink="https://github.com/JamshaidAhmedd/ChatBot_CSSPMS.GRAMMAR"
              techStack="Node.js • NLP • WhatsApp API • Automation"
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
